import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-transactionUp",
  "use": "icon-transactionUp-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-transactionUp\"><defs><style type=\"text/css\"></style></defs><path d=\"M320 512h384v512H320V512z m192-512l448.768 512H63.232z\" fill=\"#E24A2B\" p-id=\"12252\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/transactionUp.svg
// module id = u7Di
// module chunks = 152